exports = module.exports = require("../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".m-body-ser{position:relative;width:816px;min-height:384px;overflow-x:hidden}.m-service{position:absolute;left:0;top:0;transition:all .5s}.m-fir-detail{margin-top:113px!important}.m-fir-detail .m-desc{width:400px;margin-left:-2px;height:380px;overflow:hidden}", ""]);

// exports



//////////////////
// WEBPACK FOOTER
// ./~/css-loader?minimize!./~/vue-loader/lib/style-compiler?{"vue":true,"id":"data-v-7e0d088c","scoped":false,"hasInlineConfig":true}!./~/vue-loader/lib/selector.js?type=styles&index=0!./src/pages/agent/selelct-service.vue
// module id = 483
// module chunks = 1